<template>

    <div class="courseList">
        <ul class="clearfix">
			<li v-for="courseItemModel in courseItem" :key="courseItemModel.id">
				<div class="course-img fl" @click="showCourse(courseItemModel.id)">
					<img :src="courseItemModel.picBigUrl" >
					<!-- <img :src="'http://image.xueyoubangbang.com/' + courseItemModel.picBigUrl"> -->
				</div>
				<div class="course-detail fl">
					<h3 class="course-tit" :title="courseItemModel.courseName" @click="showCourse(courseItemModel.id)">{{courseItemModel.courseName}}</h3>
					<p>主讲：<em>{{courseItemModel.teacherName}}</em></p>
					<p v-if="courseItemModel.courseType == 'VIDEO'">有效期{{courseItemModel.courseValidity}}天</p>
					<p v-else-if="courseItemModel.courseType == 'LIVE' || courseItemModel.courseType =='TEACH_METHOD_FACE'" v-show="courseItemModel.lessonStartTime == null ||courseItemModel.lessonEndTime == null">有效期：{{courseItemModel.lessonStartTime?courseItemModel.lessonStartTime.substr(5,5):''}} ~{{courseItemModel.lessonEndTime?courseItemModel.lessonEndTime.substr(5,5):''}}</p>
					<p v-else>暂无课程安排</p>
					<div class="money-btns">
						<span class="fl money"> 
							<em v-if="courseItemModel.realPrice == 0 && courseItemModel.realPrice == 0">免费</em>
							<em v-else>￥{{courseItemModel.realPrice}}</em>
						</span>
						<span class="btns-wrap fr">
							<a href="javascript:void(0);" class="try-btn">去体验</a>
							<a href="javascript:void(0);" class="enroll-btn" @click="showCourse(courseItemModel.id)">去报名</a>
						</span>
					</div>
					<!-- <div class="remain-num">
						<h4>18</h4>
						剩余名额
					</div> -->
				</div>
			</li>
		</ul>
    </div>
</template>

<script>
export default {
    props:{
		courseItem:{},
    },
    
    methods:{
        
        //显示课程详情
        showCourse(courseId){
            this.$router.push('/courseInfo/'+courseId)
        }
	}
}
</script>
<style  scoped="scoped">
    .courseList ul li{
        margin:5px 20px 5px 0;
    }
    
    .courseList ul li:nth-child(2n){
        margin-right: 0;
    }
    
    .courseList ul li{
		width: 590px;
		height: 150px;
		background: #fff;
		box-sizing: border-box;
		padding:10px;
		border-radius: 4px;
		font-size: 14px;
		float: left;
		color: #646b8a;
	}
	.course-img{
		width: 216px;
		height: 130px;
		margin-right: 15px;
		overflow: hidden;
		cursor: pointer;
	}
	.course-img img{
		min-width: 100%;
		min-height: 100%;
		max-width: 100%;
		max-height: 100%;
	}
	.course-detail{
		width: 336px;
		position: relative;
		cursor: default;
	}
	.course-detail h3{
		font-weight: bold;
		padding: 10px 0;
		width: 180px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		cursor: pointer;
	}
	.course-detail p{
		margin-bottom: 10px;
		width: 180px;
	}
	
	.btns-wrap a{
		display: inline-block;
		width: 72px;
		height: 30px;
		line-height: 30px;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		margin-left: 10px;
		position: relative;
		overflow: hidden;
	}
	.btns-wrap a:hover:before{
		content: '';
		display: block;
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		z-index: 10;
		background: rgba(0,0,0,.2);
	}
	.money{
		font-size:16px;
		line-height: 30px;
		color: #ff6060;
	}
	.btns-wrap a.try-btn{
		background: #f49d40;
		display: none;
	}
	.btns-wrap a.enroll-btn{
		background: #ff6060;
	}
	.remain-num{
		position: absolute;
		top:5px;
		right: 0px;
		text-align: center;
	}
	.remain-num h4{
		font-weight: bold;
		font-size: 16px;
		color: #ff6060;
	}
</style>